import { createSlice, PayloadAction } from "@reduxjs/toolkit"

type LogEntry = string

export interface LogSliceState {
	entries: LogEntry[]
	lapStartAt: number|null
}

const initialState: LogSliceState = {
	entries: [],
	lapStartAt: null
}

const logSlice = createSlice({
	name: 'log',
	initialState,
	reducers: {
		pushLogEntry(state, action: PayloadAction<LogEntry>) {
			let entry = action.payload
			if(state.lapStartAt) {
				const delta = Date.now() - state.lapStartAt
				entry += ` (+${delta}ms)`
			}
			state.entries.push(entry)
		},
		setLogLapStart(state) {
			state.lapStartAt = Date.now()
			state.entries.push(`[logSlice] lap started at ${Date.now()}`)
		},
		setLogLapEnd(state) {
			if(state.lapStartAt) {
				const delta = Date.now() - state.lapStartAt
				state.entries.push(`[logSlice] lap ended at ${Date.now()} (+${delta}ms)`)
				state.lapStartAt = null
			}
		}
	}
})

export const { pushLogEntry, setLogLapStart, setLogLapEnd } = logSlice.actions
export default logSlice.reducer
